/* global $ */
import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import AccessControlView from '@/views/AccessControl/AccessControlView.vue';
import { get_token, getCookie } from '@/router/index.js';
import Swal from 'sweetalert2';

export default {
  name: 'UserPermissionsView',
  components: {
    Sidebar,
    Navbar,
    AccessControlView,
  },

  data: () => ({
    csrf_token: '',
    user_id: null,
    user_name: '',
    user_email: '',
    user_role: '',
    user_client_type: '',
    user_status: '',
    user: null,
    permissions: [],

    active_tab: 'user',

    role_permissions: [],
    user_permissions: [],
    all_permissions: [],
    available_permissions: [],

    loading: false,
    modal_loading: false,
    show_assign_modal: false,
    show_edit_profile_modal: false,
    show_details_modal: false,
    selected_permission_details: null,

    search_query: '',
    selected_permissions: [],

    // Edit profile form data
    first_name: '',
    last_name: '',
    email: '',
    client_type_id: '',
    role_id: '',
    is_active: true,
    edit_form_errors: {},
    roles: [],
    client_types: [],
    returning_to_assign_modal: false,
  }),

  computed: {
    role_permissions_count() {
      return this.role_permissions.length;
    },

    role_active_count() {
      return this.role_permissions.filter(p => p.is_active).length;
    },

    role_inactive_count() {
      return this.role_permissions.filter(p => !p.is_active).length;
    },

    user_permissions_count() {
      return this.user_permissions.length;
    },

    user_active_count() {
      return this.user_permissions.filter(p => p.is_active).length;
    },

    user_inactive_count() {
      return this.user_permissions.filter(p => !p.is_active).length;
    },

    all_permissions_count() {
      return this.all_permissions.length;
    },

    all_active_count() {
      return this.all_permissions.filter(p => p.is_active).length;
    },

    all_inactive_count() {
      return this.all_permissions.filter(p => !p.is_active).length;
    },

    filtered_available_permissions() {
      if (!this.search_query) return this.available_permissions;

      const query = this.search_query.toLowerCase();
      return this.available_permissions.filter(p => {
        const name_match = p.name.toLowerCase().includes(query);
        const desc_match = p.description && p.description.toLowerCase().includes(query);
        const type_match = p.permission_type && p.permission_type.toLowerCase().includes(query);
        const features_match = p.main_features && p.main_features.some(f =>
          f.toLowerCase().includes(query)
        );

        return name_match || desc_match || type_match || features_match;
      });
    },

    current_permissions() {
      if (this.active_tab === 'role') return this.role_permissions;
      if (this.active_tab === 'user') return this.user_permissions;
      return this.all_permissions;
    },

    total_count() {
      if (this.active_tab === 'role') return this.role_permissions_count;
      if (this.active_tab === 'user') return this.user_permissions_count;
      return this.all_permissions_count;
    },

    active_count() {
      if (this.active_tab === 'role') return this.role_active_count;
      if (this.active_tab === 'user') return this.user_active_count;
      return this.all_active_count;
    },

    inactive_count() {
      if (this.active_tab === 'role') return this.role_inactive_count;
      if (this.active_tab === 'user') return this.user_inactive_count;
      return this.all_inactive_count;
    }
  },

  mounted() {
    this.csrf_token = getCookie('csrftoken');
    this.user_id = this.$route.params.user_id;
    this.user_name = this.$route.query.name || '';
    this.user_email = this.$route.query.email || '';
    this.user_role = this.$route.query.role || '';

    if (!this.user_id) {
      this.$notyf.error('Invalid user');
      this.$router.back();
      return;
    }

    this.fetch_user_details();
    this.fetch_permissions();
    this.fetch_roles();
    this.fetch_client_types();

  },

  methods: {

    async fetch_roles() {
      const token = get_token();
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_roles_for_user_creation/`, {
        headers: { 'Authorization': `Token ${token}` },
        credentials: 'include',
      });
      const data = await response.json();

      if (response.ok && data.status === "success") {
        this.roles = data.data || [];
      } else {
        console.error("Failed to fetch roles:", data.message);
      }
    },

    async fetch_client_types() {
      const token = get_token();
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_all_client_types/`, {
        headers: { 'Authorization': `Token ${token}` },
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok && data.status === "success") {
        this.client_types = data.data || [];
      } else {
        console.error("Failed to fetch client types:", data.message);
      }
    },

    async fetch_user_details() {
        const token = get_token();
        const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_details?user_id=${this.user_id}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                    'X-CSRFToken': this.csrf_token,
                    'X-Page-URL': window.location.href
                },
            });

            if (response.ok) {
                const data = await response.json();
                this.user = data;
                this.user_name = `${data.first_name} ${data.last_name}`;
                this.user_email = data.email;
                this.user_role = data.role;
                this.user_client_type = data.client_type;
                this.user_status = data.is_active ? 'Active' : 'Inactive';
            } else {
                const error_data = await response.json();
                console.error('Error response:', error_data);
            }
        } catch (error) {
            console.error('Error fetching user details:', error);
        }
    },

    async fetch_permissions() {
        this.loading = true;
        const token = get_token();

        try {
            await Promise.all([
                this.fetch_role_permissions(token),
                this.fetch_user_permissions(),
                this.fetch_available_permissions(),
            ]);

            this.combine_all_permissions();
            this.initialize_data_table();
        } catch (error) {
            this.$notyf.error('Error loading permissions');
        } finally {
            this.loading = false;
        }
    },

    async fetch_role_permissions(token) {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_role_permissions?user_id=${this.user_id}`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.role_permissions = (data.permissions || []).map(p => ({
            ...p,
            source: 'role',
            main_features: p.main_features || [],
            main_features_detailed: p.main_features_detailed || []
          }));
        }
      } catch (error) {
        console.error('Error fetching role permissions:', error);
      }
    },

    async fetch_user_permissions() {
        const token = get_token();
        const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_permissions?user_id=${this.user_id}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                    'X-CSRFToken': this.csrf_token,
                    'X-Page-URL': window.location.href
                },
            });

            if (response.ok) {
                const data = await response.json();
                this.user_permissions = (data.permissions || []).map(p => ({
                    ...p,
                    source: 'user',
                    main_features: p.main_features || [],
                    main_features_detailed: p.main_features_detailed || []
                }));
            } else {
                const error_data = await response.json();
                console.error('Error response:', error_data);
            }
        } catch (error) {
            console.error('Error fetching user permissions:', error);
        }
    },

    async fetch_available_permissions() {
        const token = get_token();
        const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_assignable_permissions_for_user?user_id=${this.user_id}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                    'X-CSRFToken': this.csrf_token,
                    'X-Page-URL': window.location.href
                },
            });

            if (response.ok) {
                const data = await response.json();
                this.available_permissions = (data.permissions || []).map(p => ({
                    ...p,
                    main_features: p.main_features || [],
                    main_features_detailed: p.main_features_detailed || []
                }));
            } else {
                const error_data = await response.json();
                console.error('Error response:', error_data);
                this.$notyf.error(error_data.message || 'Failed to fetch assignable permissions');
            }
        } catch (error) {
            console.error('Error fetching available permissions:', error);
            this.$notyf.error('Error fetching available permissions');
        }
    },

    combine_all_permissions() {
        const permission_map = new Map();

        this.role_permissions.forEach(rp => {
            const perm_id = rp.permission_id || rp.id;
            permission_map.set(perm_id, { ...rp });
        });

        this.user_permissions.forEach(up => {
            const perm_id = up.permission_id || up.id;
            if (permission_map.has(perm_id)) {
                const existing = permission_map.get(perm_id);
                permission_map.set(perm_id, {
                    ...up,
                    source: 'both',
                    role_active: existing.is_active,
                    user_active: up.is_active
                });
            } else {
                permission_map.set(perm_id, { ...up });
            }
        });

        this.all_permissions = Array.from(permission_map.values());
    },

    switch_tab(tab) {
      const table_el = $('#permissions_table');
      if (table_el.length && $.fn.DataTable && $.fn.DataTable.isDataTable(table_el)) {
        table_el.DataTable().destroy();
      }

      this.active_tab = tab;

      this.$nextTick(() => {
        if (this.active_tab !== 'all') {
          this.initialize_data_table();
        }
      });
    },

    show_permission_details(permission) {
      // If assign modal is open, remember it
      if (this.show_assign_modal) {
        this.returning_to_assign_modal = true;
        this.show_assign_modal = false; // Close assign modal first
      }

      this.selected_permission_details = permission;
      this.show_details_modal = true;
    },

    // Update the close_details_modal method
    close_details_modal() {
      this.show_details_modal = false;
      this.selected_permission_details = null;

      // If we came from assign modal, reopen it
      if (this.returning_to_assign_modal) {
        this.$nextTick(() => {
          this.show_assign_modal = true;
          this.returning_to_assign_modal = false;
        });
      }
    },

    open_assign_modal() {
      this.show_assign_modal = true;
      this.selected_permissions = [];
      this.search_query = '';
    },

    // Also update close_assign_modal to reset the flag
    close_assign_modal() {
      this.show_assign_modal = false;
      this.selected_permissions = [];
      this.search_query = '';
      this.returning_to_assign_modal = false; // Reset flag
    },

    open_edit_profile_modal() {
      if (!this.user) {
        this.$notyf.error('User data not loaded');
        return;
      }

      const name_parts = this.user_name.split(' ');
      const user_role = this.roles.find(r => r.name === this.user.role);
      const user_client_type = this.client_types.find(ct => ct.name === this.user_client_type);

      this.id = this.user_id;
      this.first_name = this.user.first_name || name_parts[0] || '';
      this.last_name = this.user.last_name || name_parts.slice(1).join(' ') || '';
      this.email = this.user_email;
      this.role_id = user_role ? user_role.id : '';
      this.client_type_id = user_client_type ? user_client_type.id : '';
      this.edit_form_errors = {};
      this.show_edit_profile_modal = true;
    },

    close_edit_profile_modal() {
      this.show_edit_profile_modal = false;
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.client_type = '';
      this.is_active = true;
      this.edit_form_errors = {};
    },

    validate_edit_form() {
      this.edit_form_errors = {};
      let is_valid = true;

      if (!this.first_name || !this.first_name.trim()) {
        this.edit_form_errors.first_name = 'First name is required';
        is_valid = false;
      }

      if (!this.last_name || !this.last_name.trim()) {
        this.edit_form_errors.last_name = 'Last name is required';
        is_valid = false;
      }

      if (!this.email || !this.email.trim()) {
        this.edit_form_errors.email = 'Email is required';
        is_valid = false;
      } else {
        const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email_pattern.test(this.email)) {
          this.edit_form_errors.email = 'Invalid email format';
          is_valid = false;
        }
      }

      return is_valid;
    },

    async save_profile_changes() {
      if (this.modal_loading) return;

      const email = (this.email || '').trim().toLowerCase();
      const first_name = (this.first_name || '').trim();
      const last_name = (this.last_name || '').trim();
      const role_id = this.role_id;
      const client_type_id = this.client_type_id;

      if (!first_name || !last_name || !email || !role_id) {
        this.$notyf.error('Please fill in all required fields.');
        return;
      }

      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      const base_url = process.env.VUE_APP_API_BASE_URL;
      const admin_url = `${base_url}/aic_one_api/system_management/admin_update_user/`;
      const org_url = `${base_url}/aic_one_api/system_management/org_admin_update_user/`;
      const current_user = JSON.parse(localStorage.getItem('user')) || {};
      const current_user_role = current_user.role || '';
      const request_url = current_user_role.toLowerCase().includes('organization') ? org_url : admin_url;

      const payload = {
        user_id: this.id,
        first_name,
        last_name,
        email,
        role_id,
        client_type_id,
      };

      if (current_user_role.toLowerCase().includes('organization')) {
        payload.org_id = current_user.company_id || current_user.org_id || null;
      }

      this.modal_loading = true;

      try {
        const response = await fetch(request_url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrf_token,
            'X-Page-URL': window.location.href,
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json().catch(() => null);

        if (!response.ok || data?.status !== 'success') {
          const friendly = this.parse_backend_error(data);
          this.$notyf.error(friendly || 'Failed to update user.');
          return;
        }

        this.$notyf.success('User updated successfully.');
        if (this.close_edit_profile_modal) this.close_edit_profile_modal();
        if (this.fetch_user_details) await this.fetch_user_details();

      } catch (err) {
        console.error('Update user error:', err);
        this.$notyf.error(`Error updating user: ${String(err)}`);
      } finally {
        this.modal_loading = false;
      }
    },

    toggle_permission_selection(permission) {
      const index = this.selected_permissions.findIndex(p => p.id === permission.id);
      if (index > -1) {
        this.selected_permissions.splice(index, 1);
      } else {
        this.selected_permissions.push(permission);
      }
    },

    is_permission_selected(permission) {
      return this.selected_permissions.some(p => p.id === permission.id);
    },

    async assign_permissions() {
      if (this.selected_permissions.length === 0) {
        this.$notyf.error('Please select at least one permission');
        return;
      }

      this.modal_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/assign_user_permissions/`;

      try {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrf_token,
          },
          body: JSON.stringify({
            user_id: this.user_id,
            permission_ids: this.selected_permissions.map(p => p.id)
          }),
        });

        if (response.ok) {
          this.$notyf.success(`${this.selected_permissions.length} permission(s) assigned successfully`);
          this.close_assign_modal();
          await this.fetch_permissions();
        } else {
          const data = await response.json();
          this.$notyf.error(data.message || 'Failed to assign permissions');
        }
      } catch (error) {
        this.$notyf.error('Error assigning permissions');
      } finally {
        this.modal_loading = false;
      }
    },

    async remove_permission(permission) {
      if (permission.source === 'role') {
        Swal.fire({
          icon: 'warning',
          title: 'Action not allowed',
          text: 'Role-based permissions cannot be removed.',
        });
        return;
      }

      const result = await Swal.fire({
        title: 'Remove permission?',
        text: `Remove "${permission.name}" from this user?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove it!',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) return;

      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/remove_user_permission/`;

      try {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrf_token,
          },
          body: JSON.stringify({
            user_id: this.user_id,
            permission_id: permission.permission_id || permission.id,
          }),
        });

        const data = await response.json();

        if (response.ok && data?.status === 'success') {
          this.$notyf?.success('Permission removed successfully');
          await this.fetch_permissions();
        } else {
          this.$notyf?.error(data?.message || 'Failed to remove permission');
        }
      } catch (error) {
        console.error('Remove permission error:', error);
        this.$notyf?.error('Error removing permission');
      }
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_el = $('#permissions_table');
        if (table_el.length && $.fn.DataTable) {
          if ($.fn.DataTable.isDataTable(table_el)) {
            table_el.DataTable().destroy();
          }
          table_el.DataTable({
            pageLength: 10,
            lengthChange: false,
            searching: true,
            ordering: true,
            paging: true,
            info: true,
            autoWidth: false,
          });
        }
      });
    },

    truncate_text(text, length = 50) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },

    go_back() {
      this.$router.back();
    }
  }
};